const labels = {
    en: {
        title: "Knowledge Transfer",
        // subtitle_1: 'Diagnosis:',
        parag_1: 'In individuals with diabetes, smoking is an independent risk factor for all-cause mortality. It increases the risk of myocardial infarction 1.4-fold, stroke by 30%, and progression to end-stage renal disease (ESRD); and is associated with poorer glycemic control. Quitting smoking has been shown to reduce cardiovascular risk in people with diabetes.',
        reference: [
            'Diabetes Canada Clinical Practice Guidelines Expert Committee, Stone JA, Houlden RL, Lin P, Udell JA, Verma S. Cardiovascular protection in people with diabetes. Can J Diabetes 2018;42 Suppl 1:S162-S169. doi:10.1016/j.jcjd.2017.10.024'
        ]
    },
    fr: {
        title: "Le transfert du savoir",        
        // subtitle_1: 'Diagnostic:',
        parag_1: "Chez les personnes diabétiques, le tabagisme est un facteur de risque indépendant de mortalité toutes causes confondues. Il augmente le risque d’infarctus du myocarde de 1,4 fois, d’accident vasculaire cérébral (AVC) de 30 % et de progression vers une insuffisance rénale terminale, et il est associé à une moins bonne maîtrise glycémique. Une étude a montré que le sevrage du tabac réduit le risque cardiovasculaire chez les personnes diabétiques.",
        reference: [
            "Comité d’experts des Lignes directrices de pratique clinique de Diabète Canada, Stone JA, Houlden RL, Lin P, Udell JA, Verma S. Protection cardiovasculaire chez les personnes diabétiques. Can J Diabetes 42 (2018) S162-S169. doi : 10.1016/j.jcjd.2017.10.024."
        ]
    }
};

export default labels